"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _selectors = require("../../selectors");
var _constants = require("@studio/constants");
/**
 * @param {*} attendeeId
 * @param {Function} updateSource
 * @returns {Function} Redux thunk action that sets sources as unassigned for the given attendeeId
 */
function setSourceAsUnassigned(attendeeId, updateSource) {
  return function (dispatch, getState) {
    var state = getState();
    var sources = (0, _selectors.selectBroadcastSources)(state);
    var source = sources.find(function (s) {
      return s.type === _constants.CAMERA_PRESENTER && s.value === attendeeId;
    });
    if (!source) {
      return;
    }
    dispatch(updateSource(source._id, {
      value: _constants.UNASSIGNED,
      thumbnail: _constants.EMPTY_THUMBNAIL
    }));
  };
}
var _default = exports["default"] = setSourceAsUnassigned;